// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2yXAu","errorLogs":"EditorFooter_errorLogs__1-ed1"};